module.exports = __webpack_public_path__ + "static/media/22861467_1638430552898796_9026230264363181921_o.cc0c707b.jpg";